import React from "react";

import "./styles.scss"
import SourceListMain from "../../esg-chat/source-list";

const RealEstateSourceList = () => {
    return (
        <SourceListMain model="RealEstate" />
    )
}

export default RealEstateSourceList